<template>
  <div class="assetDetailTags">
    <section class="assetDetailTags-title">
      <div class="assetDetailTags-title-title">
        <h3>TAGS</h3>
      </div>
      <div class="assetDetailTags-title-controls">
        <neb-button @click="onEditClick">Edit</neb-button>
      </div>
    </section>
    <section class="assetDetailTags-topics">
      <tags-topics :topics="topics" />
    </section>
    <section class="assetDetailTags-keywords">
      <tags-keywords :keywords="keywords" />
    </section>
    <section class="assetDetailTags-properties">
      <tags-properties :pageUrlId="pageUrlId" />
    </section>
  </div>
</template>

<script>
import TagsTopics from './TagsTopics.vue'
import TagsKeywords from './TagsKeywords.vue'
import TagsProperties from './TagsProperties.vue'
import NebButton from '@/components/Nebula/controls/Button'

export default {
  name: 'AssetDetailTags',

  components: {
    TagsTopics,
    NebButton,
    TagsKeywords,
    TagsProperties
  },

  props: {
    topics: {
      type: Array,
      default: () => []
    },
    keywords: {
      type: Array,
      default: () => []
    },
    pageUrlId: {
      type: String,
      reqired: true
    }
  },

  emits: [
    'action:edit'
  ],

  setup (props, { emit }) {
    const onEditClick = () => emit('action:edit')

    return {
      onEditClick
    }
  }
}
</script>

<style lang="scss">
@import '../Nebula/style.scss';

.assetDetailTags {
  section {
    &:not(.assetDetailTags-title) {
      padding-bottom: 20px;
    }
  }

  &-title {
    display: flex;
    justify-content: space-between;

    &-title {
      h3 {
        font-family: $defaultFont;
        font-size: 14px;
        font-weight: 300;
        color: $slate-grey;
        margin: 0;
      }
    }
  }
}
</style>
